import { generateTableOrderedList, generateTableUnOrderedList, sectionStyle, tableHeader, tableParagraph } from "../ChapterList";

import { styled } from "@mui/material/styles";
import { tableCellClasses } from "@mui/material/TableCell";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
const borderColor = "#AAAAAA";
const specialBorderColor = "#F3F3F4";

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "#CCE5E5",
    verticalAlign: "baseline",
  },
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#F45B69",
    color: theme.palette.common.white,
    fontWeight: 700,
    fontSize: "16px",
    border: `1px solid ${borderColor}`,
    verticalAlign: "baseline",
  },
  [`&.${tableCellClasses.body}`]: {
    fontfamily: "Lato",
    fontSize: "15px",
    fontWeight: 400,
    lineHeight: "27px",
    color: "rgb(85, 85, 85)",
    border: `1px solid ${borderColor}`,
  },
  "&:first-child": {
    borderLeft: `1px solid ${specialBorderColor}`,
  },
  "&:last-child": {
    borderRight: `1px solid ${specialBorderColor}`,
  },
}));

const pointStyle = {
  fontFamily: "Lato",
  fontSize: "15px",
  fontWeight: "400",
  lineHeight: "27px",
  color: "#555555",
  letterSpacing: "0em",
  textAlign: "justified",
  margin: "10px 20px",
};


const sectionDetailsfirstArray = [
  <><span style={sectionStyle}>(iv)</span> Subject to maintaining independence, impartiality and credibility of judicial proceedings, and subject to such directions as the High Court may issue, Courts may adopt such technological advances as may become available from time to time.</>,
];

const designConsiderationsFirstArray = [
  "Relevant technology must be adopted in the Courtroom for the District Court proceedings from time to time.",
];

const sectionDetailsSecondArray = [
  "The following equipment is recommended for conducting proceedings by video conferencing at the Court Point and at the Remote Point:",
  <><span style={sectionStyle}>(i)</span> Desktop, Laptop, mobile devices with internet connectivity and printer</>,
  <><span style={sectionStyle}>(ii)</span> Device ensuring uninterrupted power supply</>,
  <><span style={sectionStyle}>(iii)</span> Camera;</>,
  <><span style={sectionStyle}>(iv)</span> Microphones and speakers;</>,
  <><span style={sectionStyle}>(v)</span> Display unit;</>,
  <><span style={sectionStyle}>(vi)</span> Document visualizer;</>,
  <><span style={sectionStyle}>(vii)</span> Provision of a firewall;</>,
  <><span style={sectionStyle}>(viii)</span> Adequate seating arrangements ensuring privacy;</>,
  <><span style={sectionStyle}>(ix)</span> Adequate lighting; and</>,
  <><span style={sectionStyle}>(x)</span> Availability of a quiet and secure space.</>,
];

const designConsiderationsSecondArray = [
  "Desktops, laptops and mobile devices with internet connectivity and printer;",
  "Device ensuring uninterrupted power supply;",
  "Cameras;",
  "Microphones and speakers;",
  "Display units;",
  "Document visualizer; and",
  "Provision of a firewall.",
];

const sectionDetailsThirdArray = [
  <><span style={sectionStyle}>5.1</span> There shall be a Coordinator both at the Court Point and at the Remote Point from which any Required Person is to be examined or heard. However, Coordinator may be required at the Remote Point only when a witness or a person accused of an offence is to be examined. </>,
  <><span style={sectionStyle}>5.8</span> Before the scheduled video conferencing date, the Coordinator at the Court Point shall ensure that the Coordinator at the Remote Point receives certified copies, printouts or a soft copy of the non-editable scanned copies of all or any part of the record of proceedings which may be required for recording statements or evidence, or for reference. However, these shall be permitted to be used by the Required Person only with the permission of the Court.</>,
  <><span style={sectionStyle}>5.9</span> Whenever required the Court shall order the Coordinator at the Remote Point or at the Court Point to provide - </>,
  <><span style={sectionStyle}>5.9.1</span> A translator in case the person to be examined is not conversant with the official language of the Court. </>,
  <><span style={sectionStyle}>5.9.2</span> An expert in sign languages in case the person to be examined is impaired in speech and/or hearing. </>,
  <><span style={sectionStyle}>5.9.3</span> An interpreter or a special educator, as the case may be, in case a person to be examined is differently abled, either temporarily or permanently</>,
];

const designConsiderationsThirdArray = [
  "Space must be provided for a Coordinator during the proceedings. ",
  "The room must be equipped with adequate computers, printout systems, scanners and other necessary technological provisions.",
  "Adequate space must be designated for all support persons including translators, sign language experts, interpreters, special educators, etc. ",
];

const sectionDetailsFourthArray = [
  <><span style={sectionStyle}>8.8.1</span> If digital signatures are available at both the concerned Court Point and Remote Point, the soft copy of the transcript digitally signed by the presiding Judge at the Court Point shall be sent by the official e-mail to the Remote Point where a print out of the same will be taken and signed by the person being examined. A scanned copy of the transcript digitally signed by the Coordinator at the Remote Point would be transmitted by official email of the Court Point. The hard copy of the signed transcript will be dispatched after the testimony is over, preferably within three days by the Coordinator at the Remote Point to the Court Point by recognised courier/registered speed post.</>,
  <><span style={sectionStyle}>8.9</span> An audio-visual recording of the examination of person examined shall be preserved. An encrypted master copy with hash value shall be retained as a part of the record</>,
  <><span style={sectionStyle}>8.10</span> The Court may, at the request of a person to be examined, or on its own motion, taking into account the best interests of the person to be examined, direct appropriate measures to protect the privacy of the person examined bearing in mind aspects such as age, gender, physical condition and recognized customs and practices. </>,
];

const designConsiderationsFourthArray = [
  "Additional technological provisions  including recording equipment, scanning equipment and equipment for  reprography must be provided.",
];

const sectionDetailsFifthArray = [
  <><span style={sectionStyle}>9.1</span> If the document is at the Court Point, by transmitting a copy or image of the document to the Remote Point electronically, including through a document visualizer;</>,
];

const designConsiderationsFifthArray = [
  "Document visualizers must be provided and adequate space must be provided for its storage when not in use. ",
];

const Table4SectionRelevant = [
  <><span style={sectionStyle}>2.1.</span> Cameras will be ordinarily installed in the Courtroom covering at least five angles; one towards the bench, the second and third towards the advocates engaged in the concerned matter, the fourth towards the accused (where applicable) and the fifth towards the deponent/witness, as required.</>,
  <><span style={sectionStyle}>2.2.</span> If the Court has employed an electronic evidence presentation system, an additional feed shall be captured therefrom.</>,
  <><span style={sectionStyle}>2.3.</span> A remote-control device shall be provided to the presiding judge on the bench to pause or stop the live streaming at any time.</>,
  <><span style={sectionStyle}>2.4.</span> Advocates, witnesses, accused, or any other person permitted by the bench, shall use appropriate microphones while addressing the Court.</>,
  <><span style={sectionStyle}>2.5.</span> In so far as a remote location is concerned, appropriate hardware will be deployed to the extent practicable, bearing in mind the provisions made in the aforementioned sub-rules.</>,
  <><span style={sectionStyle}>2.6.</span> Where proceedings are conducted through weblinks, including video conferencing services, appropriate software and hardware will be employed, if necessary, to generate an integrated feed for live streaming.</>,
];

const tableHeading = {
  color: "#000",
  fontSize: "1rem",
  fontWeight: 600,
  paddingRight: "5px",
};

export const TableHeader = () => {
  return (
    <TableHead>
      <TableRow>
        <StyledTableCell>Section No.</StyledTableCell>
        <StyledTableCell>Section Title</StyledTableCell>
        <StyledTableCell>Section Relevant Details</StyledTableCell>
        <StyledTableCell>Design Considerations</StyledTableCell>
      </TableRow>
    </TableHead>
  );
};

export const Table3 = () => {
  return (
    <TableContainer>
      <Table aria-label="customized table">
        <TableHeader />
        <TableBody>
          <StyledTableRow>
            <StyledTableCell>S.3</StyledTableCell>
            <StyledTableCell style={tableHeader}>General Principles Governing Video Conferencing</StyledTableCell>
            <StyledTableCell style={{ paddingTop: "0px !important" }}>{generateTableOrderedList(sectionDetailsfirstArray)}</StyledTableCell>
            <StyledTableCell>{generateTableUnOrderedList(designConsiderationsFirstArray)}</StyledTableCell>
          </StyledTableRow>

          <StyledTableRow>
            <StyledTableCell>S.4</StyledTableCell>
            <StyledTableCell style={tableHeader}>Facilities recommended for Video Conferencing</StyledTableCell>
            <StyledTableCell>{generateTableOrderedList(sectionDetailsSecondArray)}</StyledTableCell>
            <StyledTableCell>
              <p style={tableParagraph}>
                Technological equipments that must be provided in the Courtroom
                include:
              </p>
              {generateTableUnOrderedList(designConsiderationsSecondArray)}
              <p>
                Additional provisions must be made to ensure privacy during the
                proceedings including adequate seating, lighting, etc.
              </p>
            </StyledTableCell>
          </StyledTableRow>

          <StyledTableRow>
            <StyledTableCell>S.5</StyledTableCell>
            <StyledTableCell style={tableHeader}>Preparatory Arrangements</StyledTableCell>
            <StyledTableCell>{generateTableOrderedList(sectionDetailsThirdArray)}</StyledTableCell>
            <StyledTableCell>{generateTableUnOrderedList(designConsiderationsThirdArray)}</StyledTableCell>
          </StyledTableRow>

          <StyledTableRow>
            <StyledTableCell>S.8</StyledTableCell>
            <StyledTableCell style={tableHeader}>Examination of Persons</StyledTableCell>
            <StyledTableCell>{generateTableOrderedList(sectionDetailsFourthArray)}</StyledTableCell>
            <StyledTableCell>{generateTableUnOrderedList(designConsiderationsFourthArray)}</StyledTableCell>
          </StyledTableRow>

          <StyledTableRow>
            <StyledTableCell>S.9</StyledTableCell>
            <StyledTableCell style={tableHeader}>Exhibiting or Showing Documents to Witness or Accused at a Remote
              Point</StyledTableCell>
            <StyledTableCell>{generateTableOrderedList(sectionDetailsFifthArray)}</StyledTableCell>
            <StyledTableCell>{generateTableUnOrderedList(designConsiderationsFifthArray)}</StyledTableCell>
          </StyledTableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export const Table4 = ({ gotosection }) => {
  const Table4DesignConsiderations = [
    "Cameras should be installed as directed in the Courtroom.",
    <>
      An electronic evidence presentation system may be made available in the
      Courtroom, with adequate feed linkage to the Direct Control Room (refer to{" "}
      <span
        style={sectionStyle}
        onClick={() =>
          gotosection("officeSpaces", "officeSpacesMultiPersonWorkspace")
        }
      >
        {" "}
        Section 2.5.C{" "}
      </span>
      )
    </>,
    "The dais must contain provision to store a remote-control device.",
    "Provision must be made for microphones at the lawyers’ seating area as well as at the witness box and accused box.",
    "Portable microphones may be utilised, if needed. ",
    <>
      For Courts in remote locations, appropriate hardware facilities should be
      made available. Refer to{" "}
      <span
        style={sectionStyle}
        onClick={() => gotosection("designAndImplementationProcess", "partD")}
      >
        {" "}
        PART D{" "}
      </span>
      of this Handbook
    </>,
    "Appropriate hardware and software must be used as directed in the Courtroom.",
  ];
  return (
    <TableContainer>
      <Table aria-label="customized table">
        <TableHeader />
        <TableBody>
          <StyledTableRow>
            <StyledTableCell>S.2</StyledTableCell>
            <StyledTableCell style={tableHeader}>Hardware - Placement & Control</StyledTableCell>
            <StyledTableCell>{generateTableOrderedList(Table4SectionRelevant)}</StyledTableCell>
            <StyledTableCell>{generateTableUnOrderedList(Table4DesignConsiderations)}</StyledTableCell>
          </StyledTableRow>

          <StyledTableRow>
            <StyledTableCell>S.4</StyledTableCell>
            <StyledTableCell style={tableHeader}>Personnel positioned in the Court</StyledTableCell>
            <StyledTableCell>
              <p style={tableParagraph}>In addition to the Court master and Court staff attached to the
                bench, technical expert(s) shall be appointed/deputed in each of
                the Court premises or designated venue to enable the live
                streaming of proceedings.</p>
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList(["Adequate space must be designated for the technical expert during proceedings."])}
            </StyledTableCell>
          </StyledTableRow>

        </TableBody>
      </Table>
    </TableContainer>
  );
};

export const Table5 = () => {
  return (
    <TableContainer>
      <Table aria-label="customized table">
        <TableHeader />
        <TableBody>
          <StyledTableRow>
            <StyledTableCell>S.6</StyledTableCell>
            <StyledTableCell style={tableHeader}>Counsellors, officers, and other employees of Family Court</StyledTableCell>
            <StyledTableCell>
              <p style={tableParagraph}>
                <span style={sectionStyle}>1.</span> The State Government shall, in consultation with the High
                Court, determine the number and categories of counsellors,
                officers and other employees required to assist a Family Court in
                the discharge of its functions and provide the Family Court with
                such counsellors, officers and other employees as it may think
                fit.
              </p>
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList(["The Court Complex must have adequate space for administrative offices for counsellors, officers, and other employees, as well as other amenities, as ay be required under the Family Court Act."])}
            </StyledTableCell>
          </StyledTableRow>

          <StyledTableRow>
            <StyledTableCell>S.11</StyledTableCell>
            <StyledTableCell style={tableHeader}>Proceedings to be held in camera</StyledTableCell>
            <StyledTableCell>
              <p style={tableParagraph}>
                In every suit or proceedings to which this Act applies, the
                proceedings may be held in camera if the Family Court so desires
                and shall be so held if either party so desires.
              </p>
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList(["Provisions must be made for masking the identity of the litigants, and for ensuring digital privacy."])}
            </StyledTableCell>
          </StyledTableRow>

          <StyledTableRow>
            <StyledTableCell>S.12</StyledTableCell>
            <StyledTableCell style={tableHeader}>Assistance of medical and welfare experts</StyledTableCell>
            <StyledTableCell>
              <p style={tableParagraph}>
                In every suit or proceedings, it shall be open to a Family Court
                to secure the services of a medical expert or such person
                (preferably a woman where available), whether related to the
                parties or not, including a person professionally engaged in
                promoting the welfare of the family as the Court may think fit,
                for the purposes of assisting the Family Court in discharging the
                functions imposed by this Act.
              </p>
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList(["Adequate space and amenities must be provided for consultation with medical and welfare experts, as may be required. Space may be allocated within the Courtroom for the medical and welfare experts, if necessary."])}
            </StyledTableCell>
          </StyledTableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export const Table6 = () => {
  return (
    <TableContainer>
      <Table aria-label="customized table">
        <TableHeader />
        <TableBody>
          <StyledTableRow>
            <StyledTableCell>S.26</StyledTableCell>
            <StyledTableCell style={tableHeader}>Additional provisions regarding statement to be recorded</StyledTableCell>
            <StyledTableCell>
              <p style={tableParagraph}>
                <span style={sectionStyle}>1.</span> The Magistrate or the police officer, as the case may be, shall
                record the statement as spoken by the child in the presence of the
                parents of the child or any other person in whom the child has
                trust or confidence.{" "}
              </p>

              {/* <p style={tableParagraph}>
                <span style={sectionStyle}>2.</span> Wherever necessary, the Magistrate or the police officer, as
                the case may be, may take the assistance of a translator or an
                interpreter, having such qualifications, experience and on payment
                of such fees as may be prescribed, while recording the statement
                of the child.
              </p>
              <p style={tableParagraph}>
                <span style={sectionStyle}>3.</span> The Magistrate or the police officer, as the case may be, may,
                in the case of a child having a mental or physical disability,
                seek the assistance of a special educator or any person familiar
                with the manner of communication of the child or an expert in that
                field, having such qualifications, experience and on payment of
                such fees as may be prescribed, to record the statement of the
                child.
              </p>
              <p style={tableParagraph}>
                {" "}
                <span style={sectionStyle}>4.</span> Wherever possible, the Magistrate or the police officer, as the
                case may be, shall ensure that the statement of the child is also
                recorded by audio-video electronic means.
              </p> */}
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList([
                "Adequate space must be provided for the presence of the parents of the child or any other support persons such as a translator, interpreter, special educator or any other expert/person familiar with the child’s manner of communication.",

                // <p style={{ marginTop: "90px" }}> Provision must be made for seating and other amenities for all such support persons, to enable recording of evidence(97). </p>,

                // <p style={{ marginTop: "340px" }}>
                //   Audio-visual facilities and other digital means of recording evidence must be provided.
                // </p>
              ])}
            </StyledTableCell>
          </StyledTableRow>

          <StyledTableRow>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell>
             
              <p style={tableParagraph}>
                <span style={sectionStyle}>2.</span> Wherever necessary, the Magistrate or the police officer, as
                the case may be, may take the assistance of a translator or an
                interpreter, having such qualifications, experience and on payment
                of such fees as may be prescribed, while recording the statement
                of the child.
              </p>
             
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList([
               
                <p> Provision must be made for seating and other amenities for all such support persons, to enable recording of evidence(97). </p>,

              ])}
            </StyledTableCell>
          </StyledTableRow>

          <StyledTableRow>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell>
              
              <p style={tableParagraph}>
                <span style={sectionStyle}>3.</span> The Magistrate or the police officer, as the case may be, may,
                in the case of a child having a mental or physical disability,
                seek the assistance of a special educator or any person familiar
                with the manner of communication of the child or an expert in that
                field, having such qualifications, experience and on payment of
                such fees as may be prescribed, to record the statement of the
                child.
              </p>
            </StyledTableCell>
            <StyledTableCell>
              
            </StyledTableCell>
          </StyledTableRow>

          <StyledTableRow>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell>
             
              <p style={tableParagraph}>
                {" "}
                <span style={sectionStyle}>4.</span> Wherever possible, the Magistrate or the police officer, as the
                case may be, shall ensure that the statement of the child is also
                recorded by audio-video electronic means.
              </p>
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList([
                
                <p>
                  Audio-visual facilities and other digital means of recording evidence must be provided.
                </p>
              ])}
            </StyledTableCell>
          </StyledTableRow>



          <StyledTableRow>
            <StyledTableCell>S.28</StyledTableCell>
            <StyledTableCell style={tableHeader}>Designation of Special Courts</StyledTableCell>
            <StyledTableCell>
              <p style={tableParagraph}>
                <span style={sectionStyle}>1.</span> For the purposes of providing a speedy trial, the State
                Government shall in consultation with the Chief Justice of the
                High Court, by notification in the Official Gazette, designate for
                each District, a Court of Session to be a Special Court to try the
                offences under the Act.
              </p>
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList(["The Special Court must be a comfortable, non-intimidating space where the child victim may be able to give their statement and hearings may be conducted in a sensitive manner."])}
            </StyledTableCell>
          </StyledTableRow>

          <StyledTableRow>
            <StyledTableCell style={{ borderBottom: "0px" }} >S.33</StyledTableCell>
            <StyledTableCell rowSpan={1} style={tableHeader}>Procedure and powers of Special Court</StyledTableCell>
            <StyledTableCell>
              <p style={tableParagraph}>
                <span style={sectionStyle}>4.</span> The Special Court shall create a child-friendly atmosphere by
                allowing a family member, a guardian, a friend or a relative, in
                whom the child has trust or confidence, to be present in the
                Court.
              </p>
              {/* <p style={tableParagraph}>
                <span style={sectionStyle}>7.</span> The Special Court shall ensure that the identity of the child
                is not disclosed at any time during the course of investigation or
                trial.
                <br />
                <br />
                <b>Explanation.--</b> For the purposes of this sub-section, the
                identity of the child shall include the identity of the child's
                family, school, relatives, neighbourhood or any other information
                by which the identity of the child may be revealed.
              </p> */}
            </StyledTableCell>
            <StyledTableCell>
              <p style={tableParagraph}>
                {generateTableUnOrderedList(["Principles for child-friendly and trauma informed design must be followed while designing all spaces within the Family Court. For further details, please refer to Section 2.3.A. "])}
              </p>

            </StyledTableCell>

          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell>
              <p style={tableParagraph}>
                <span style={sectionStyle}>7.</span> The Special Court shall ensure that the identity of the child
                is not disclosed at any time during the course of investigation or
                trial.
                <br />
                <br />
                <b>Explanation.--</b> For the purposes of this sub-section, the
                identity of the child shall include the identity of the child's
                family, school, relatives, neighbourhood or any other information
                by which the identity of the child may be revealed.
              </p>
            </StyledTableCell>
            <StyledTableCell style={{verticalAlign:"baseline"}}>

              {generateTableUnOrderedList(["Adequate provisions must be made for masking details relating to the child victim."])}

            </StyledTableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell>S.36</StyledTableCell>
            <StyledTableCell style={tableHeader}>Child not to see accused at the time of testifying</StyledTableCell>
            <StyledTableCell className="tablesixpoints">
              <p style={tableParagraph}>
                <span style={sectionStyle}>1.</span> The Special Court shall ensure that the child is not exposed in
                any way to the accused at the time of recording of the evidence,
                while at the same time ensuring that the accused is in a position
                to hear the statement of the child and communicate with his
                advocate.
              </p>
              <p style={tableParagraph}>
                {" "}
                <span style={sectionStyle}>2.</span> For the purposes of sub-section (1), the Special Court may
                record the statement of a child through video conferencing or by
                utilising single visibility mirrors or curtains or any other
                device.
              </p>
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList([
                "The Special Court must have provisions for single-visibility mirrors, curtains, or any other such separative device, to ensure that the child victim does not come into contact with the accused at the time of giving testimony."," The Special Court, the POCSO waiting area for the child victims, and the separate waiting area for the accused must be equipped with video-conferencing facilities."," Additional security provisions must be adopted wherever necessary to ensure that the child does not see the accused at the time of testifying."])}

            </StyledTableCell>
          </StyledTableRow>

          <StyledTableRow>
            <StyledTableCell>S.37</StyledTableCell>
            <StyledTableCell style={tableHeader}>Trials to be conducted in camera</StyledTableCell>
            <StyledTableCell>
              <p style={tableParagraph}>
                The Special Court shall try cases in camera and in the presence of
                the parents of the child or any other person in whom the child has
                trust or confidence.
              </p>
            </StyledTableCell>
            <StyledTableCell style={{ verticalAlign: "middle" }}>
              {generateTableUnOrderedList(["Provisions must be made for masking the identity of the child and for ensuring digital privacy."])}
            </StyledTableCell>
          </StyledTableRow>

          <StyledTableRow>
            <StyledTableCell>S.39</StyledTableCell>
            <StyledTableCell style={tableHeader}>Guidelines for child to take assistance of experts, etc.</StyledTableCell>
            <StyledTableCell>
              <p style={tableParagraph}>
                Subject to such rules as may be made in this behalf, the State
                Government shall prepare guidelines for use of non-governmental
                organisations, professionals and experts or persons having
                knowledge of psychology, social work, physical health, mental
                health and child development to be associated with the pre-trial
                and trial stage to assist the child.
              </p>
            </StyledTableCell>
            <StyledTableCell style={{ verticalAlign: "middle" }}>
              {generateTableUnOrderedList(["Adequate space and amenities must be provided for the use of non-governmental organisations, professionals, experts or any other support persons present at the stage of trial before the Special Court."])}
            </StyledTableCell>
          </StyledTableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};
